import React from "react";
import { ReactComponent as Heart } from "svgs/fi-rs-heart.svg";
import { ReactComponent as WhiteHeart } from "svgs/fi-rs-white-heart.svg";
import { ReactComponent as BeigeHeart } from "svgs/fi-rs-beige-heart.svg";
import { useWishlist } from "hooks/useStore";
import useToggle from "hooks/useToggle";
import WishlistModal from "./modal";

const WishlistModalTriggerButton = ({ className = "", product, beigeHeart = false, iconClassName }) => {
	const { savedListItems } = useWishlist(["savedListItems"]);
	const [isWishlistModalOpen, toggleWishlistModal] = useToggle();
	const isInWishlist = savedListItems?.some((item) => item.epi === +product.variant.id);

	const Icon = () => {
		if (isInWishlist) {
			return beigeHeart ? <BeigeHeart className={iconClassName} /> : <WhiteHeart className={iconClassName} />;
		}
		return <Heart className={iconClassName} />;
	};

	const handleClick = (e) => {
		e.stopPropagation();
		e.preventDefault();
		toggleWishlistModal();
	};

	const handleToggleModal = () => {
		toggleWishlistModal();
	};

	return (
		<>
			{isWishlistModalOpen &&
				// Prevent click event from propagating to parent elements
				<div onClick={(e) => e.stopPropagation()}>
					<WishlistModal product={product} isOpen={isWishlistModalOpen} toggle={handleToggleModal} />
				</div>}
			<button
				onClick={handleClick}
				onKeyDown={(e) => e.key === "Enter" && handleClick(e)}
				aria-label="Add to wishlist"
				className={className}>
				<Icon />
			</button>
		</>
	);
};


export default WishlistModalTriggerButton;